import { useState, useEffect } from 'react';
import { useAppContext, SET_WINDOWS, SET_FACADE, SET_HOUSE_SIZE } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useUrlState } from '../utils/urlState';
import { MobileView, BrowserView } from 'react-device-detect';
import WindowChoice from '../components/WindowChoice';
import HouseMaterial from '../components/HouseMaterial';
import HouseSize from '../components/HouseSize';
import PreviewSVG from '../components/PreviewSVG';
import HouseEditorMobile from './HouseEditor.mobile';
import houseButton from '../images/ui_buttons/house_button.png';
import fenceButton from '../images/ui_buttons/fence_button.png';
import nextButton from '../images/ui_buttons/next_button.png';
import backButton from '../images/ui_buttons/back_button.png';
// import fenceMetalButton from '../images/ui_buttons/fenceMetal_button.png';
// import fenceWoodenButton from '../images/ui_buttons/fenceWooden_button.png';
// import '../css/body.css';

const HouseEditor = () => {
	const [isFacadeSelected, setIsFacadeSelected] = useState(false);
	const [isSizeSelected, setIsSizeSelected] = useState(false);
	const [isWindowSelected, setIsWindowSelected] = useState(false);
	const [isHouseEditorDone, setIsHouseEditorDone] = useState(false);
	const [showFacadeChoiceButtons, setShowFacadeChoiceButtons] = useState(true);
	const [showFenceButtons] = useState(true);
	const { state, dispatch } = useAppContext();
  const { facade, houseSize, windows } = state.currentDesign || {};
	const navigate = useNavigate();
	const { navigateWithParams } = useUrlState();

	// Navigate to the next screen
	const handleNext = () => {
		console.log(state);
		navigateWithParams('/style', {
			zone: state.currentDesign?.zone,
			facade: state.currentDesign?.facade,
			houseSize: state.currentDesign?.houseSize,
			windows: state.currentDesign?.windows
		});
	};

	// Navigate to the previous screen
	const handleBack = () => {
		console.log(state);
		navigate('/zone');
	};

	// Logic for choosing the background to be a house or a fence
	const handleHouseClick = () => {
		setShowFacadeChoiceButtons(false);

    if (!windows) {
      dispatch({ type: SET_WINDOWS, payload: "windows_none" });
    }
    if (!houseSize) {
      dispatch({ type: SET_HOUSE_SIZE, payload: 12 });
    }
    if (!facade || facade === "none" || facade === "fence_wooden") {
      dispatch({ type: SET_FACADE, payload: "siding_white" });
    }
	};

	// Logic for setting the selected window configuration
	const handleWindowSelection = (windowId) => {
		dispatch({ type: SET_WINDOWS, payload: windowId });
		setIsWindowSelected(true);
	};

	// Logic for choosing selected house
	const handleFacadeSelection = (facadeId) => {
		dispatch({ type: SET_FACADE, payload: facadeId });
    
    if (["fence_wooden", "none"].includes(facadeId)) {
      dispatch({ type: SET_WINDOWS, payload: null });
      dispatch({ type: SET_HOUSE_SIZE, payload: null });
    }
    
		setIsFacadeSelected(true);
	};

	const handleFenceClick = () => {
    handleFacadeSelection("fence_wooden");
		// setShowFenceButtons(true);
	};

  const handleNoneClick = () => {
    handleFacadeSelection("none");
  };

	// Logic for choosing the size of the house
	const handleHouseSizeSelection = (houseSizeId) => {
		dispatch({ type: SET_HOUSE_SIZE, payload: houseSizeId });
		setIsSizeSelected(true);
	};

	// Logic for navigating back to choosing house or fence
	const handleBackToFacadeChoice = () => {
		setShowFacadeChoiceButtons(true);
	};

	useEffect(() => {
		if (facade) {
			setIsFacadeSelected(true);
		}
		if (windows) {
			setIsWindowSelected(true);
		}
		if (houseSize) {
			setIsSizeSelected(true);
		}

		// Allow the editor to be marked as done for a fence or a house
		if (
			facade === 'fence_wooden' ||
			facade === 'none' ||
			(facade && houseSize && windows)
		) {
			setIsHouseEditorDone(true);
		} else {
			setIsHouseEditorDone(false);
		}
	}, [facade, windows, houseSize]);



	return (
		<>
			<BrowserView>
				<div className='full-container'>
					<header>
						<button onClick={handleBack}>
							<img src={backButton} alt='Back' className='button-image' />
						</button>
						<h1>Your House</h1>
						<button
							onClick={handleNext}
							disabled={!isHouseEditorDone}
							className={`next-button ${isHouseEditorDone ? 'active' : 'inactive'}`}>
							<img src={nextButton} alt='Next' className='button-image' />
						</button>
					</header>
					<div className='house-container'>
						<div className='left-side-buttons-container'>
							<div className='facade-buttons-header-container'>
								<h2>Choose your landscape background</h2>
							</div>
							{showFacadeChoiceButtons ? (
								<div className='initial-facade-buttons-container'>
									<button className='initial-facade-button' onClick={handleHouseClick}>
										<img src={houseButton} alt='House' className='facade-image' />
									</button>
									<button
										className={`initial-facade-button ${
											facade === 'fence_wooden' ? 'selected' : ''
										}`}
										onClick={() => handleFenceClick()}>
										<img src={fenceButton} alt='Fence' className='facade-image' />
									</button>
									<button
										className={`initial-facade-button ${
											facade === 'none' ? 'selected' : ''
										}`}
										onClick={() => handleNoneClick()}>
										<h2>None</h2>
									</button>
								</div>
							) : (
								<>
									<div className='facade-buttons-container'>
										<HouseMaterial
											selectedFacade={facade}
										/>
										<HouseSize
											onSizeClick={handleHouseSizeSelection}
											selectedHouseSize={houseSize}
										/>
										<WindowChoice
											onWindowClick={handleWindowSelection}
											selectedWindow={windows}
										/>
									</div>
									<button
										className='facade-back-button'
										onClick={handleBackToFacadeChoice}>
										Back to Facade Choice
									</button>
								</>
							)}
						</div>
						<div className='house-svg-container'>
							<PreviewSVG />
						</div>
					</div>
				</div>
			</BrowserView>
      <MobileView>
				<HouseEditorMobile
					// State functions
					isFacadeSelected={isFacadeSelected}
					isSizeSelected={isSizeSelected}
					isWindowSelected={isWindowSelected}
					isHouseEditorDone={isHouseEditorDone}
					showFacadeChoiceButtons={showFacadeChoiceButtons}
					showFenceButtons={showFenceButtons}
					facade={facade}
					houseSize={houseSize}
					windows={windows}
					
					// Handle functions
					handleNext={handleNext}
					handleBack={handleBack}
					handleHouseClick={handleHouseClick}
					handleFenceClick={handleFenceClick}
					handleNoneClick={handleNoneClick}
					handleBackToFacadeChoice={handleBackToFacadeChoice}
					handleFacadeSelection={handleFacadeSelection}
					handleHouseSizeSelection={handleHouseSizeSelection}
					handleWindowSelection={handleWindowSelection}
				/>
			</MobileView>
		</>
	);
};

export default HouseEditor;
